



































































































































import { Vue, Prop, Component, Watch, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { submitWork } from "@/services/api/submission";
import { getProofread, saveProofRead } from "@/services/api/proofreads";
import LoaderMixin from "@/mixins/loader";
import NotificationMixin from "@/mixins/notification";

@Component
export default class ProofcheckForm extends mixins(
  LoaderMixin,
  NotificationMixin
) {
  @Prop({ type: Boolean, default: false }) private showDialog: boolean;
  @Prop(Number) private submissionId: number;
  @Prop(Number) private submissionUserId: number;
  private dialog: boolean = false;
  private valid: boolean = false;
  private title: string = "";
  private mensagemOrganizacao = "";
  private items = {
    workOriginalite: {
      valueSelected: 0,
      title: "Originalidade do trabalho: ",
      subtitle:
        "Como você avalia a originalidade do trabalho apresentado nesse artigo?",
      options: [
        { value: 5, text: "5. Muito original" },
        { value: 4, text: "4. Originalidade acima da média" },
        { value: 3, text: "3. Originalidade média" },
        { value: 2, text: "2. Pouca originalidade" },
        { value: 1, text: "1. Nenhuma originalidade" }
      ]
    },
    areaContribution: {
      valueSelected: 0,
      title: "Contribuição para a área: ",
      subtitle: "Como você avalia a contribuição do artigo para a área?",
      options: [
        { value: 5, text: "5. Grande contribuição para a área" },
        { value: 4, text: "4. Contribuição significante" },
        { value: 3, text: "3. Contribuição pequena, mas clara" },
        { value: 2, text: "2. Pouca contribuição" },
        {
          value: 1,
          text: "1. Nenhuma contribuição discernível para a área"
        }
      ]
    },
    technicalQuality: {
      valueSelected: 0,
      title: "Qualidade técnica: ",
      subtitle:
        "Como você avalia a qualidade técnica do trabalho apresentado nesse artigo?",
      options: [
        { value: 5, text: "5. Excelente" },
        { value: 4, text: "4. Boa" },
        { value: 3, text: "3. Média" },
        { value: 2, text: "2. Baixa" },
        {
          value: 1,
          text: "1. Inaceitável"
        }
      ]
    },
    presentationOrganization: {
      valueSelected: 0,
      title: "Organização e apresentação: ",
      subtitle: `Como você avalia a legibilidade, clareza e organização desse artigo?
         As citaçôes e formatação estão de acordo com o estilo da conferência?`,
      options: [
        { value: 5, text: "5. Excelente" },
        { value: 4, text: "4. Boa" },
        { value: 3, text: "3. Média" },
        { value: 2, text: "2. Baixa" },
        {
          value: 1,
          text: "1. Inaceitável"
        }
      ]
    },
    recomendation: {
      valueSelected: 0,
      title: "Recomendação para esse trabalho: ",
      subtitle: "O que você recomenda para esse artigo?",
      options: [
        {
          value: 5,
          text:
            "5. Deve ser aceito - Tenho fortes argumentos a favor da aceitação"
        },
        {
          value: 4,
          text:
            "4. Aceitação fraca - Não irei lutar fortemente pela aceitação desse trabalho"
        },
        { value: 3, text: "3. Neutro - Não tenho certeza" },
        {
          value: 2,
          text: "2. Rejeição fraca - Não irei lutar fortemente contra"
        },
        {
          value: 1,
          text:
            "1. Não deve ser aceito - Tenho fortes argumentos a favor da não aceitação"
        }
      ]
    },
    trust: {
      valueSelected: "",
      title: "Confiança do revisor: ",
      subtitle: "Qual é a sua confiança a respeito dessa revisão?",
      options: [
        { value: 3, text: "Sou um especialista na área" },
        {
          value: 2,
          text: "Sou familiarizado com trabalho nessa área"
        },
        { value: 1, text: "Não sou um especialista na área" }
      ]
    },
    category: {
      valueSelected: "",
      title: "Categoria: ",
      subtitle: "Em qual categoria o trabalho se enquadra?",
      options: [
        { value: "oral-presentation", text: "Apresentação Oral" },
        { value: "poster", text: "Poster" }
      ]
    }
  
  };

  constructor() {
    super();
  }

  @Watch("showDialog")
  private showDialogChanged(newValue: boolean, oldValue: boolean) {
    this.dialog = newValue;
  }

  private hideDialog() {
    this.$emit("hidden");
  }

  private async saveRevision() {
    for (let prop in this.items) {
      if (Object.prototype.hasOwnProperty.call(this.items, prop)) {
        // @ts-ignore
        if (!this.items[prop].valueSelected) {
          this.showErrorNotification("Por favor, preencha todos os campos.");
          return;
        }
      }
    }
    let data = {
      userId: this.submissionUserId,
      submissionId: this.submissionId,
      originalidade: this.items.workOriginalite.valueSelected,
      contribuicao: this.items.areaContribution.valueSelected,
      qualidade: this.items.technicalQuality.valueSelected,
      organizacao: this.items.presentationOrganization.valueSelected,
      recomendacao: this.items.recomendation.valueSelected,
      confiancaRevisor: this.items.trust.valueSelected,
      categoria: this.items.category.valueSelected,
      mensagemOrganizacao: this.mensagemOrganizacao
    };
    this.showLoader();
    saveProofRead(data)
      .then(() => {
        this.showSuccessNotification("Revisão enviada com sucesso.");
        this.hideLoader();
        this.hideDialog();
        this.$emit("loadData");
      })
      .catch(err => {
        this.hideLoader();
        console.log(err);
        this.showErrorNotification("Ocorreu um problema ao enviar revisão.");
      });
  }
}
